import { Menu, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { toolbarPopoverButton } from '@/lib/buttonStyles';

/**
 * Desktop signed-out hamburger. Uses the same DropdownMenu infrastructure as
 * the authed UserMenu (no sliding tray). Sole action is "Page Owner Login" →
 * /owner. Mobile still uses <MobileMenu /> for its bottom-drawer surface.
 */
export const GuestMenu = () => {
	const navigate = useNavigate();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					aria-label="Menu"
					className={cn(
						toolbarPopoverButton,
						'h-10 w-10 p-0 rounded-full focus-visible:ring-0 focus-visible:ring-offset-0',
					)}
				>
					<Menu className="w-5 h-5 text-foreground/80" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				className="w-52 backdrop-blur-md bg-black/30 border-white/[0.08] shadow-[inset_0_1px_1px_rgba(255,255,255,0.03)]"
			>
				<DropdownMenuItem className="cursor-pointer" onClick={() => navigate('/owner')}>
					<span className="mr-2 inline-flex h-4 w-4 items-center justify-center shrink-0">
						<LogIn className="h-4 w-4" />
					</span>
					<span>Page Owner Login</span>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
